"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const debug_provider_1 = __importDefault(require("../components/debug/debug-provider"));
const page_debug_1 = __importDefault(require("../components/debug/page-debug"));
const language_provider_1 = __importDefault(require("../components/language/language-provider"));
const global_seo_1 = __importDefault(require("../components/global-seo"));
const gatsby_query_store_1 = require("./gatsby-query-store");
const json_ld_1 = __importDefault(require("../components/json-ld"));
const Layout = (props) => {
    const { children, location, pageContext, globalData } = props;
    if (!globalData) {
        throw new Error("globalData is required on AtollonProvider.");
    }
    // need also head content in here
    return (react_1.default.createElement(gatsby_query_store_1.GatsbyQueryStore, { data: globalData },
        react_1.default.createElement(json_ld_1.default, { ...props }),
        react_1.default.createElement("style", { type: "text/css", id: "atl-asset", dangerouslySetInnerHTML: {
                __html: `
                   .atl-asset {
                        position: relative;
                    }
                    .atl-asset video {
                        object-fit: var(--object-fit);
                        object-position: var(--object-position);
                    }
                    .atl-asset .play {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        opacity: 0;
                        transition: opacity 0.3s;
                    }
                    .atl-asset[data-playing="false"] .play {
                        opacity: 1;
                    } 
                `
            } }),
        react_1.default.createElement(debug_provider_1.default, { id: (props?.pageContext).originalId },
            react_1.default.createElement(page_debug_1.default, { ...props }),
            react_1.default.createElement(language_provider_1.default, { ...props },
                react_1.default.createElement(global_seo_1.default, { ...props }),
                children))));
};
exports.default = Layout;
//# sourceMappingURL=index.js.map